import React from 'react';
import TimeAgo from 'react-timeago';
import { Image } from "react-bootstrap";
import {  NavLink } from 'react-router-dom';
import { FileService } from 'src/services/file.service';
import { localizedStrings } from 'src/localization/index.jsx';

import styles from './styles.module.scss';
import cx from "classnames";
import _ from 'lodash';

const DefaultAssetIcon ='/images/defaultIcons/default_asset.jpg'

class LiveView extends React.Component{

  constructor(props){
    super(props);

    this.state = {
      asset: null,
      share: null,
      page: false,
      thumbnail: null,
      assetId: null,
      shareId: null,
      pageNumber: 0
    }

    this.toggleLiveView = this.toggleLiveView.bind(this);
    this.localizedEngage = localizedStrings.pages.engage;
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
  }

  componentDidMount(){
    this.props.fetchAsset(this.props.assetId).then(() => {
      this.props.fetchPreviewAsset(this.props.assetId);
    });
    this.props.fetchConversation(this.props.shareId);
  }

  componentWillReceiveProps(nextProps){
    if (!_.isEqual(this.props.assetId, nextProps.assetId)) {
      this.props.fetchAsset(nextProps.assetId).then(() => {
        this.props.fetchPreviewAsset(nextProps.assetId);
      });
    }

    if (!_.isEqual(this.props.shareId, nextProps.shareId)) {
      this.props.fetchConversation(nextProps.shareId);
    }

    if (!_.isEqual(this.props.share, nextProps.share)) {
      this.setState({
        share: nextProps.share[this.props.shareId].item
      })
    }

    if(!_.isEqual(this.props.pages, nextProps.pages)){
      if (nextProps.asset){
        var page = FileService.hasPageAnalytics(nextProps.asset.metadata);

    if (page) {
      this.setState({
          thumbnail: nextProps.pages && nextProps.pages[parseInt(nextProps.pageNumber - 1)].background ? nextProps.pages[parseInt(nextProps.pageNumber - 1)].background.thumbnail : "",
          page: true,
          pageNumber: parseInt(nextProps.pageNumber)
        })
      } else {
        this.setState({
          thumbnail: nextProps.asset && nextProps.asset.icon.full
      })
    }
  }
}

    if (!_.isEqual(this.props.asset, nextProps.asset)){
      this.setState({
        asset: nextProps.asset,
        thumbnail: _.get(nextProps.asset, 'icon.full') || DefaultAssetIcon
      })
    }

    if (this.state.asset && !_.isEqual(this.props.pageNumber, nextProps.pageNumber)){
      var page = FileService.hasPageAnalytics(this.props.asset.metadata);
      if(page){
        this.setState({
          thumbnail: this.props.pages[parseInt(nextProps.pageNumber)].background ? this.props.pages[parseInt(nextProps.pageNumber)].background.thumbnail : DefaultAssetIcon,
          page: true,
          pageNumber: parseInt(nextProps.pageNumber) + 1
        })
      } else {
        this.setState({
          thumbnail: _.get(nextProps.asset, 'icon.full') || DefaultAssetIcon
        })
      }
    }
  }

  toggleLiveView(){
    this.props.toggleLiveView();
  }

  renderShareDetails(){
    var conversationSource = this.state.share.source;
    const localizedAssetsCount = this.localizedEngage.individual_chat.chat_details;
    const localizedPage = this.localizedEngage.individual_chat.chat_details.sliders;

    if (conversationSource == "Paperflite QuickSend") {
      conversationSource = localizedAssetsCount.quicksend;
    } else if (conversationSource == "Paperflite Link") {
      conversationSource = this.localizedCommons.link;
    }

    return (
      <div>
        <p className={styles.subjectName}>
          {this.state.share.subject}
        </p>
        <p className={styles.assetsCount}>
          {localizedStrings.formatString(
            localizedAssetsCount.sliders.shared_asset,
            this.state.share.totalAssetsCount > 1 ? (
              <span className={styles.totalAssetsCount}>
                {this.state.share.totalAssetsCount}{" "}
                {this.localizedKeywords.assets}
              </span>
            ) : (
              <span className={styles.totalAssetsCount}>
                {this.state.share.totalAssetsCount}{" "}
                {this.localizedKeywords.asset}
              </span>
            )
          )}
        </p>
        <p className={styles.timeAgo}>
          {localizedStrings.formatString(
            localizedAssetsCount.sliders.shared_time,
            {
              createdDate: (
                <TimeAgo date={this.state.share.createdDate} live={false} />
              ),
              conversationSource: conversationSource,
            }
          )}
        </p>
        <Image className={styles.thumbnail} src={this.state.thumbnail}></Image>
        {this.state.page && _.get(this.state, 'asset.metadata.pages') &&
          <p className={styles.page}>{localizedPage.observing_page} {this.state.pageNumber}/{this.state.asset.metadata.pages}</p>
        }
        <NavLink to={`/assets/${this.state.asset.id}`} className={styles.groupLink}>
          <p className={styles.assetName}>{this.state.asset.name}</p>
        </NavLink>
      </div>
    )
  }
  

  render() {
    return(
      <div className={styles.liveView}>
        <div className={styles.verticalLine}></div>
        <button onClick={this.toggleLiveView} className={styles.closeButton}>
            <i className={cx(styles.closeButton, "paperflite-close")} />
        </button>
        {!this.state.share && 
          <p className={styles.loadingMessage}>{`${this.localizedCommons.loading.loading}...`}</p>
        }
        {this.state.share && this.state.asset && 
          this.renderShareDetails()
        }
      </div>
    )
  }
}

export default LiveView;
